
export function ordenarArray<T>(array: T[], esAscendente: 1 | -1, key: keyof T) {
  if (array.length === 0) return array;
  return array.sort((a,b) => {
    const aValue = a[key];
    const bValue = b[key];
    if(typeof aValue === 'number' && typeof bValue === 'number') return (aValue > bValue ? esAscendente : -esAscendente);
    if(typeof aValue === 'string' && typeof bValue === 'string') return (aValue.toLowerCase() > bValue.toLowerCase() ? esAscendente : -esAscendente);
    if(typeof aValue === 'boolean' && typeof bValue === 'boolean') return (aValue > bValue ? esAscendente : -esAscendente);
  })
}